import type { FilterState, FilterAction } from '../models/hooks'
import type { FilterStashType } from '../utils'

const createEmptyFilters = (prevState: FilterStashType): FilterStashType =>
  Object.keys(prevState).reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: []
    }),
    {} as FilterStashType
  )

export const filtersReducer = (
  state: FilterState,
  action: FilterAction
): FilterState => {
  switch (action.type) {
    case 'SET_FILTER':
      return { ...state, filtersStash: action.payload, scrollToContainer: true }
    case 'SET_SORT':
      return { ...state, sort: action.payload, scrollToContainer: true }
    case 'BACKUP':
      return {
        ...state,
        backupFiltersStash: state.filtersStash,
        backupHistoryFilters: state.historyFilters
      }
    case 'RESTORE':
      return {
        ...state,
        filtersStash: state.backupFiltersStash ?? state.filtersStash,
        historyFilters: state.backupHistoryFilters,
        backupFiltersStash: null,
        backupHistoryFilters: []
      }
    case 'RESET':
      return {
        ...state,
        filtersStash: createEmptyFilters(state.filtersStash),
        historyFilters: [],
        sort: '',
        scrollToContainer: false
      }
    case 'SET_SCROLL':
      return { ...state, scrollToContainer: action.payload }
    case 'SYNC_ENABLED': {
      const enabledFilters = action.payload
      const newFiltersStash = Object.entries(state.filtersStash).reduce(
        (acc, [key, values]) => ({
          ...acc,
          [key]: values.filter((item) => enabledFilters[key]?.includes(item))
        }),
        {} as FilterStashType
      )
      return { ...state, filtersStash: newFiltersStash }
    }
    case 'INIT':
      return {
        ...state,
        filtersStash: action.payload.filtersStash,
        sort: action.payload.sort,
        historyFilters: action.payload.historyFilters
      }
    case 'SET_HISTORY':
      return { ...state, historyFilters: action.payload }
    default:
      return state
  }
}
